{
	"main": {
		"title": "Lista di Partenza Voli a Motore",
		"nezakljuceni": "VOLI NON COMPLETATI",
		"zakljuceni": "VOLI COMPLETATI"
	},
	"table": {
		"reg": "REG.",
		"datum": "DATA",
		"vzlet": "DECOLLO",
		"pilot": "PILOTA",
		"naloga": "COMPITO",
		"pristanek": "ATTERRAGGIO",
		"titleU": "Elenco dei voli ultraleggeri"
	},
	"labels": {
		"datumOd": "Data DA:",
		"datumDo": "Data A:",
		"pilotJ": "Seleziona pilota aliante:",
		"instruktor": "Seleziona istruttore aliante:",
		"registracijaJ": "Seleziona matricola aliante:",
		"namenJ": "Seleziona scopo:",
		"nalogaJ": "Seleziona compito dell’aliante:",
		"pilotM": "Seleziona pilota del rimorchiatore:",
		"registracijaM": "Seleziona matricola rimorchiatore:",
		"vzlet": "Seleziona decollo:",
		"pristanek": "Seleziona atterraggio:",
		"poletanje": "Decollo:",
		"odklop": "SGANCIO:",
		"nezakljucen": "Volo non completato?",
		"pristanekJ": "Atterraggio aliante:",
		"pristanekM": "Atterraggio rimorchiatore:",
		"opomba": "Nota",
		"niMozno": "Questa registrazione non può essere modificata qui. Modificala nella sezione dei voli a vela!"
	},
	"modal": {
		"registracija": "registrazione",
		"pilot": "pilota",
		"vlecno": "aereo rimorchiatore:",
		"instruktor": "istruttore:",
		"namen": "scopo:",
		"naloga": "compito:",
		"vzlet": "luogo decollo:",
		"pristanek": "luogo atterraggio:",
		"casVzleta": "ora decollo:",
		"casOdklopa": "ora sgancio:",
		"casPristanka": "ora atterraggio:",
		"casLetenja": "tempo di volo:",
		"stPristankov": "numero atterraggi:",
		"ifr": "ifr:",
		"nocno": "notturno:",
		"vizuelno": "visivo:",
		"opomba": "nota:",
		"datumL": "data volo:",
		"datumV": "data inserimento:",
		"stanjeStevca": "posizione del contatore: "
	},
	"edit": {
		"titleJ": "DATI DELL' ALIANTE",
		"reg": "Seleziona matricola aereo:",
		"pilot": "Seleziona pilota:",
		"instruktor": "Seleziona istruttore:",
		"namen": "Seleziona scopo:",
		"naloga": "Seleziona compito:",
		"titleM": "DATI DEL RIMORCHIATORE",
		"pilotM": "pilota rimorchiatore:",
		"regM": "matricola rimorchiatore",
		"titleS": "DATI GENERALI",
		"krajV": "Seleziona decollo:",
		"krajP": "Seleziona atterraggio:",
		"opomba": "Nota:"
	},
	"modalNL": {
		"title": "Concludi la registrazione selezionata",
		"reg": "registrazione:",
		"pilot": "pilota:",
		"instruktor": "istruttore",
		"namen": "scopo:",
		"naloga": "compito:",
		"casV": "ora decollo:",
		"krajV": "luogo decollo:",
		"krajP": "luogo atterraggio:",
		"pristanekM": "Atterraggio dell’aereo a motore:",
		"klubL": "Club dell’aereo:",
		"klubP": "Club del pilota:",
		"casL": "tempo di volo:",
		"opomba": "nota:",
		"datumL": "data volo:",
		"datumV": "data inserimento:",
		"stanjeStevca": "posizione del contatore: ",
		"v_zraku": "Durata del volo: "
	},
	"buttons": {
		"zakljuciLet": "Concludi volo",
		"brisiIzbiro": "Cancella selezione",
		"urediPodatke": "Modifica dati",
		"posodobiPodatke": "Aggiorna dati",
		"izbrisiZapis": "Elimina record",
		"csv": "Esporta in CSV",
		"natisni": "Stampa",
		"poslji": "Invia"
	},
	"data": {
		"title": "Dati",
		"stPristankov": "N. atterraggi:",
		"stLetov": "N. voli:",
		"casVZraku": "Durata:"
	},
	"obvestila": {
		"zapisPrihodnost": "La registrazione ha una data impostata nel futuro, CORREGGI la data selezionata!",
		"zapisCasPrihodnost": "Una o più registrazioni hanno un’ora impostata nel futuro, controlla gli orari!",
		"zapisCasNapaka": "Gli orari della registrazione non sono corretti! Controlla di nuovo gli orari!",
		"napakaPristanka": "L’orario di atterraggio non può essere precedente a quello di decollo!",
		"zapisPobrisan": "Registrazione eliminata con successo",
		"napakaPrazenPristanek": "Errore di inserimento, l’orario di atterraggio non può essere vuoto",
		"posodobitevUspesna": "Aggiornamento riuscito",
		"napakaPosodabljanja": "Errore durante l’aggiornamento dei dati.",
		"napakaBranja": "Errore durante la lettura dei dati.",
		"napakaIzbrisa": "Errore durante l’eliminazione dei dati.",
		"vprasanjeIzbris": "Sei sicuro di voler eliminare questa registrazione?",
		"napakaVnosa": "Errore di inserimento, verifica che tutti i campi siano compilati!",
		"letZakljucen": "Volo completato con successo.",
		"letNiZakljucen": "Errore durante la conclusione del volo."
	}
}